<template>
  <div>
    <div class="header">
      <Row>
        <Col span="12">
        <img @click="HomeRout" style="margin-left: 100px" class="logo" src="@/assets/img/logo.png" alt="" />
        <div class="header_tit">
          <span @click="HomeRout" style="font-size: 18px">百科在线-国家知识服务融合出版平台</span><br />
          <span @click="HomeRout" style="font-size: 12px">(国家知识服务平台融合出版分平台)</span>
        </div>
        </Col>
        <Col span="7">
        <Input v-model="inquireInt" :placeholder="inquireIntText" class="headerInt" v-if="showPlat"
          @keyup.enter.native="inquire">
        <Select v-model="selected" slot="prepend" style="width: 80px">
          <Option value="1">期刊</Option>
          <Option value="2">论文</Option>
        </Select>
        <Button slot="append" @click="inquire" icon="ios-search"></Button>
        </Input>
        </Col>
        <Col span="5">
        <div v-if="!user" class="register" @click="login">
          <span v-if="test">注册</span>
          <span v-if="test" style="margin: 0 3px">/</span>
          <span v-if="test">登录</span>
        </div>
        <div class="message" v-if="user">
          <span @click="meassageChange">消息 </span>
          <span @click="tiaoAuthor" style="margin-left: 10px" v-text="
            !user.realname
              ? user.mobile
                ? user.mobile + '  您好！'
                : user.username + '  您好！'
              : user.realname + '  您好！'
          ">
          </span>
          <span class="quit" @click="quit">退出</span>
        </div>
        </Col>
      </Row>
    </div>
    <login :dllogin="dllogin" @livets="dealgata"></login>
  </div>
</template>

<script>
import DataApi from "@/api/home";
import DataLogin from "@/api/login";
import { GetRequest } from "@/utils/utils";
import login from "./login";
export default {
  name: "HomeHeader",
  components: {
    login,
  },
  data() {
    return {
      user: "",
      dllogin: false,
      inquireInt: "",
      selected: "1",
      test: true,
      name: "",
      token: "",
      test: false,
      inquireIntText: "请输入期刊名称",
    };
  },
  props: ["showPlat"],
  methods: {
    dealgata(lisves) {
      this.dllogin = lisves;
    },
    keyupClick(name) {
      this.$nextTick(() => {
        vm.$refs[name].focus();
      });
    },
    HomeRout() {
      sessionStorage.removeItem("searchName");
      sessionStorage.removeItem("searchType");
      sessionStorage.removeItem("pageNo");
      this.$router.push({ name: "home" });
    },
    meassageChange() {
      // 测试环境
      let pathDev = `http://dev.cnknowledge.com/newtsgweb/?token=${sessionStorage.getItem(
        "token"
      )}#/manage/otherSettings?tab=message`;

      //预生产环境
      let pLrelease = `http://yutsg.cnknowledge.com/newtsgweb/?&token=${sessionStorage.getItem(
        "token"
      )}#/manage/otherSettings?tab=message`;

      // 正式环境
      let pathProd = `http://publish.cnknowledge.com/newtsgweb/?token=${sessionStorage.getItem(
        "token"
      )}#/manage/otherSettings?tab=message`;
      var path = "";
      if (
        location.host.indexOf("dev.") != -1 ||
        location.host.indexOf("test") != -1 ||
        location.host.indexOf(":80") != -1
      ) {
        path = pathDev; //投审稿作者端测试环境
      } else if (location.host.indexOf("yu.") != -1) {
        path = pLrelease; // 投审稿作者端预生产环境
      } else {
        path = pathProd; // 投审稿作者端正式环境
      }
      window.open(path);
    },
    tiaoAuthor() {
      // 测试环境
      let pathDev = `http://dev.cnknowledge.com/newtsgweb/?token=${sessionStorage.getItem(
        "token"
      )}#/manage/mySubmission`;

      //预生产环境
      let pLrelease = `http://yutsg.cnknowledge.com/newtsgweb/?&token=${sessionStorage.getItem(
        "token"
      )}#/manage/mySubmission`;

      // 正式环境
      let pathProd = `http://publish.cnknowledge.com/newtsgweb/?&token=${sessionStorage.getItem(
        "token"
      )}#/manage/mySubmission`;

      var path = "";
      if (
        location.host.indexOf("dev.") != -1 ||
        location.host.indexOf("test") != -1 ||
        location.host.indexOf(":80") != -1
      ) {
        path = pathDev; //投审稿作者端测试环境
      } else if (location.host.indexOf("yu.") != -1) {
        path = pLrelease; // 投审稿作者端预生产环境
      } else {
        path = pathProd; // 投审稿作者端正式环境
      }

      window.open(path);
    },
    login() {
      localStorage.setItem("dllogin", true);
      this.dllogin = true;
      // window.location.href = process.env.VUE_APP_API_URL + "/tsg-author/index?isbk=true";
      // window.location.href = DataLogin.loginUrl
    },
    quit() {
      this.toLogin();
      this.name = "";
      this.token = window.sessionStorage.removeItem("token");
    },
    toLogin() {
      let that = this;
      DataLogin.logOut().then((res) => {
        if (res.resultCode == 200) {
          window.sessionStorage.clear();
          that.$router.go(0);
        }
      });
      // if (sessionStorage.getItem('userinfo')) {
      //   this.$Message.warning('已退出登录')
      //   setTimeout(function () {
      //     window.location.href =
      //       process.env.VUE_APP_API_URL +
      //       `/tsg-author/logout?Authorization=${that.token}&isbk=true`
      //     window.sessionStorage.clear()
      //   }, 1500)
      // }
    },
    inquire() {
      if (this.selected == "1" && this.inquireInt) {
        this.$router.push({
          path: "/search",
          query: {
            pageNo: 1,
            name: this.inquireInt,
            type: 1,
          },
        });
        this.inquireInt = "";
      } else if (this.selected == "2" && this.inquireInt) {
        this.$router.push({
          path: "/search",
          query: {
            pageNo: 1,
            name: this.inquireInt,
            type: 2,
          },
        });
        this.inquireInt = "";
      }
    },
    IsPC() {
      if (
        window.navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPad|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        this.test = false;
      } else {
        this.test = true;
      }
    },
    getPk() {
      DataLogin.getPk().then((res) => {
        sessionStorage.setItem("trip", res.content.pk);
        if (res.content.token) {
          sessionStorage.setItem("token", res.content.token);
          this.getUserInfoMe()
        } else {
          sessionStorage.removeItem("token")
          sessionStorage.removeItem("userInfo")
        }
      });
    },
    getUserInfoMe() {
      DataLogin.getUserInfo().then((res) => {
        if (res.resultCode == 200) {
          window.sessionStorage.setItem("userInfo", JSON.stringify(res.content.detail));
          if (res.content.detail.userInfo != undefined) {
            this.user = res.content.detail.userInfo;
          } else {
            this.user = res.content.detail.sysUser;
          }
        }
      });
    },
  },
  computed: {
    nickName() {
      return this.$store.state.Login.userName;
    },
    toPath() {
      return this.$route.path;
    },
  },
  watch: {
    selected: {
      handler(v, o) {
        if (v == "1") this.inquireIntText = "请输入期刊名称";
        else this.inquireIntText = "请输入论文标题";
      },
    },
    dllogin(vale) {
      this.dllogin = vale;
    },
  },
  created() {
    this.IsPC();
    this.getPk();
  },
  mounted() { },
};
</script>

<style scoped lang="less">
.header {
  width: 100%;
  height: 100px;
  background-color: #f9f9fa;
  border-bottom: 1px solid #959595;
  min-width: 1280px;

  .message {
    margin-left: 40px;

    span {
      cursor: pointer;
    }

    span:hover {
      color: #007fff;
    }
  }
}

.header img {
  width: 120px;
  height: 68px;
  cursor: pointer;
}

.header .header_tit {
  margin-left: 15px;
  cursor: pointer;
  text-align-last: justify;
}

.header /deep/.ivu-input-wrapper {
  border-radius: 23px;
  height: 35px;
}

.header /deep/.ivu-input-wrapper input {
  height: 40px;
}

/deep/.ivu-col {
  display: flex;
  height: 100px;
  align-items: center;
}

.header .register {
  margin-left: 80px;
}

.register:hover {
  color: #007fff;
  cursor: pointer;
}

.header .quit {
  margin-left: 15px;
  cursor: pointer;
}

.header .quit:hover {
  color: #007fff;
}

.headerInt {
  /deep/.ivu-input-group-append {
    border-radius: 20px;
    width: 50px;
    background: #fff !important;
  }

  /deep/.ivu-input-group-prepend {
    border-radius: 20px;
    width: 50px;
    background: #fff !important;
  }

  /deep/.ivu-input:hover {
    outline: none;
    border: 1px solid #dcdee2;
    box-shadow: 0 0 0 2px transparent;
  }

  /deep/ .ivu-input:focus {
    outline: none;
    border: 1px solid #dcdee2;
    box-shadow: 0 0 0 2px transparent;
  }

  .ivu-btn:focus {
    box-shadow: none !important;
  }
}
</style>
